import { BasketMarketOfferEntity } from '@genial/services';
import { Utils } from '@genial/utils';

import { OperationType } from '../../../pages/BatchTicket/components/DynamicAsset/contexts/constants';
import { formattedToday, messageError } from '../constants';

import { baseNormalization, normalizeCustomerBasketOffersData } from '.';

const getEquityDetails = (
  item: ReturnType<typeof normalizeCustomerBasketOffersData>[number],
  dailyVariation: string,
  operationType: OperationType
) => {
  return [
    { label: 'Informações do mercado:', value: '', style: 'bold' },
    { label: 'Preço atual', value: item.offer.lastPriceFormatted ?? messageError },
    {
      label: 'Variação diária',
      value: dailyVariation,
      icon: item.offer.priceChangeTax && item.offer.priceChangeTax > 0 ? 'ArrowUp' : 'ArrowDown',
    },
    { label: 'Característica da pré-boleta:', value: '', style: 'bold' },
    { label: 'Operação', value: operationType === 'buy' ? 'COMPRA' : 'VENDA' },
    {
      label: 'Tipo da ordem',
      value: item.orderType ?? messageError,
    },
    { label: 'Validade', value: formattedToday },
    { label: 'Quantidade', value: item.quantity },
    { label: 'Preço por ativo', value: Utils.Mask.Money(item.amount || 0) },
  ];
};

export const normalizeCustomerBasketOffersEquity = (data?: BasketMarketOfferEntity[]) => {
  if (!data) {
    return [];
  }

  const equityData = data.find((item) => item.marketType === 'Equity');

  if (!equityData) {
    return [];
  }

  const equityNormalizedData = normalizeCustomerBasketOffersData(equityData?.basketOffers);

  return equityNormalizedData.map((item) => {
    const dailyVariation =
      item.offer.priceChangeTax && item.offer.lastUpdatedAtFormatted
        ? `${item.offer.priceChangeTax}% ${item.offer.lastUpdatedAtFormatted}`
        : messageError;

    return {
      ...baseNormalization(item),
      type: equityData.marketTypeTranslated || messageError,
      title: item.offer.productDisplay,
      productCategory: 'AÇÕES',
      details: getEquityDetails(item, dailyVariation, item.operationType),
      total: {
        label: item.operationType === 'buy' ? 'Valor da aplicação' : 'Valor do resgate',
        value: item.requestedAmountFormatted,
      },
    };
  });
};
